import { eraseCookie, getCookie, setCookie } from "../utils/cookieHelper";

// --- Exported Functions ---

// ปรับปรุง authenticate
export const authenticate = (res, next) => {
  if (typeof window !== "undefined") {
    // เข้ารหัสก่อน save ลง cookie
    const encryptedToken = res.token;
    const encryptedUser = res.userInfo;
    setCookie("token", encryptedToken, 1);
    setCookie("userPayload", encryptedUser, 1);
  }
  if (typeof next === "function") next();
};

// นำไปใช้ใน getToken
export const getToken = () => {
  if (window !== "undefiend") {
    const encoded = getCookie("token");
    return encoded;
  }

};
// ปรับปรุง getToken
export const getUser = () => {
  if (window !== "undefiend") {
    let data = null;
    const cipherText = getCookie("userPayload");
    if (cipherText) {
      data = cipherText.userInfo;
    }
    return data;
  }
};
export const getUserInfo = () => {
  if (window !== "undefiend") {
    let data = null;
    const cipherText = getCookie("userPayload");
    if (cipherText) {
      data = cipherText.userInfo;
    }
    return data;
  }
};

export const getLoginTime = () => {
  if (window !== "undefiend") {
    return getCookie("sessionInfo");
  }
};

export const getValidateMerchant = () => {
  return getCookie("validateMerchant") || false;
};

// --- SessionStorage Logic (สำหรับข้อมูลชั่วคราว/Array) ---

export const logout = async () => {
  if (typeof window !== "undefined") {
    // ลบ Cookies
    const cookiesToErase = ["token", "userPayload", "sessionInfo", "validateMerchant"];
    cookiesToErase.forEach(name => eraseCookie(name));

    localStorage.removeItem("selectedID");
    localStorage.removeItem("UpdateAuto");
    localStorage.removeItem("AppBehaviorManager");
    sessionStorage.removeItem("appLogoutAlertShown");
    sessionStorage.removeItem("tokenExpiredAlertShow");
    sessionStorage.removeItem("addMerchantData");
    sessionStorage.removeItem("Interval");

    window.location.assign("/");
  }
};
export const removeLocalStorage = async () => {
  if (typeof logout === "function") {
    await logout();
  }
};

export { setCookie, getCookie }; // Export เผื่อเรียกใช้ที่อื่น